import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useNavigate } from "react-router-dom";

interface MyRatingChartProps {
    library: any[]; 
}

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#00C49F', '#FFBB28', '#FF8042'];

const options = {
    colors: COLORS,
    legend: {
        position: "none",
    },
    chartArea: {
        top: 20,
        width: '100%', // vergroot dit voor een grotere pie
        height: '80%'
    },
};

const MyRatingChart: React.FC<MyRatingChartProps> = ({library}) => {
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const navigate = useNavigate();

    const formatData = () => {
        let starsArray = [
            {
                label: '⭐️',
                value: 1,
                count: 0
            },
            {
                label: '⭐️⭐️',
                value: 2,
                count: 0
            },
            {
                label: '⭐️⭐️⭐️',
                value: 3,
                count: 0
            },    
            {
                label: '⭐️⭐️⭐️⭐️',
                value: 4,
                count: 0
            },
            {
                label: '⭐️⭐️⭐️⭐️⭐️',
                value: 5,
                count: 0
            }
        ];

        library.forEach((book) => {
            const rating = Math.round(book["My Rating"]) || 0;
            const index = starsArray.findIndex((star) => star.value === rating);
            if (index !== -1) {
                starsArray[index].count++;
            }
        });

        const result = starsArray.map((star) => [star.label, star.count]);

        // Add column headers
        const finalData: (string | number)[][] = [["", "Count"], ...result];

        setFormattedData(finalData);
    };

    useEffect(() => {
        formatData();
    }, [library]);

    if (library.length <= 0) {
        // loader
        return (
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }

    return(
         <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
            <h1 className="text-2xl font-bold  text-[#60637A]">
                My Ratings
            </h1>

             <div  style={{ width: '100%', height: '300px', cursor: 'pointer' }} className="pt-[20px]">
                <Chart
                    chartType="Bar"
                    data={formattedData}
                    options={options}
                    width={"100%"}
                    height={"100%"}
                    chartEvents={[
                        {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                            const chart = chartWrapper?.getChart();
                            const selection = chart?.getSelection();

                            if (selection?.length === 0) return;

                            const selectedItem = selection?.[0];
                            const rowIndex = selectedItem?.row;

                            if (rowIndex !== null) {
                            const label = formattedData[rowIndex + 1][0]; // +1 vanwege headers
                            console.log(label, label.length);

                            navigate('/stats/details?value=' + label.length/2 + '&type=rating');
                            }
                        },
                        },
                    ]}
                />
            </div>
        </div>
    )
}

export default MyRatingChart